import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { availableStatus, StatusIdentifierComponent } from '@group24ag/flowkit';

@Component({
  imports: [ReactiveFormsModule, FormsModule, StatusIdentifierComponent],
  selector: 'app-ui-status-identifiers',
  template: `
    <div>
      <h1 class="heading-title">Status Identifiers</h1>
      <div class="flex flex-col gap-10">
        @for (status of availableStatus; track $index) {
          <div class="flex flex-col gap-y-2">
            <flk-status-identifier [status]="status" />
            <flk-status-identifier [status]="status" [labelPosition]="'left'" />
            <flk-status-identifier
              [status]="status"
              [labelPosition]="'none'"
              [showHalo]="true" />
          </div>
        }
      </div>
    </div>
  `,
})
export class UIStatusIdentifiersComponent {
  protected readonly availableStatus = availableStatus;
}
